export const phoneCode = [
  {
    text: '中国大陆',
    code: '+86',
    value: '0086',
  },
  {
    text: '台湾',
    code: '+886',
    value: '00886',
  },
  {
    text: '中国香港',
    code: '+852',
    value: '00852',
  },
  {
    text: '中国澳门',
    code: '+853',
    value: '00853',
  },
  {
    text: '马来西亚',
    code: '+60',
    value: '0060',
  },
  {
    text: '新加坡',
    code: '+65',
    value: '0065',
  },
  {
    text: '日本',
    code: '+81',
    value: '0081',
  },
  {
    text: '韩国',
    code: '+82',
    value: '0082',
  },
  {
    text: '美国',
    code: '+1',
    value: '001',
  },
  {
    text: '加拿大',
    code: '+1',
    value: '001',
  },
  {
    text: '澳大利亚',
    code: '+61',
    value: '0061',
  },
  {
    text: '新西兰',
    code: '+64',
    value: '0064',
  },
  {
    text: '阿尔巴尼亚',
    code: '+355',
    value: '00355',
  },
  {
    text: '阿根廷',
    code: '+54',
    value: '0054',
  },
  {
    text: '阿联酋',
    code: '+971',
    value: '00971',
  },
  {
    text: '阿曼',
    code: '+968',
    value: '00968',
  },
  {
    text: '阿塞拜疆',
    code: '+994',
    value: '00994',
  },
  {
    text: '爱尔兰',
    code: '+353',
    value: '00353',
  },
  {
    text: '埃及',
    code: '+20',
    value: '0020',
  },
  {
    text: '爱沙尼亚',
    code: '+372',
    value: '00372',
  },
  {
    text: '安哥拉',
    code: '+244',
    value: '00244',
  },
  {
    text: '奥地利',
    code: '+43',
    value: '0043',
  },
  {
    text: '巴布亚新几内亚',
    code: '+675',
    value: '00675',
  },
  {
    text: '巴哈马',
    code: '+1242',
    value: '001242',
  },
  {
    text: '巴勒斯坦',
    code: '+970',
    value: '00970',
  },
  {
    text: '巴林',
    code: '+973',
    value: '00973',
  },
  {
    text: '巴拿马',
    code: '+507',
    value: '00507',
  },
  {
    text: '巴西',
    code: '+55',
    value: '0055',
  },
  {
    text: '白俄罗斯',
    code: '+375',
    value: '00375',
  },
  {
    text: '保加利亚',
    code: '+359',
    value: '00359',
  },
  {
    text: '贝宁',
    code: '+229',
    value: '00229',
  },
  {
    text: '比利时',
    code: '+32',
    value: '0032',
  },
  {
    text: '波兰',
    code: '+48',
    value: '0048',
  },
  {
    text: '玻利维亚',
    code: '+591',
    value: '00591',
  },
  {
    text: '伯利兹',
    code: '+501',
    value: '00501',
  },
  {
    text: '布基纳法索',
    code: '+226',
    value: '00226',
  },
  {
    text: '赤道几内亚',
    code: '+240',
    value: '00240',
  },
  {
    text: '丹麦',
    code: '+45',
    value: '0045',
  },
  {
    text: '德国',
    code: '+49',
    value: '0049',
  },
  {
    text: '多哥',
    code: '+228',
    value: '00228',
  },
  {
    text: '俄罗斯',
    code: '+7',
    value: '007',
  },
  {
    text: '法国',
    code: '+33',
    value: '0033',
  },
  {
    text: '菲律宾',
    code: '+63',
    value: '0063',
  },
  {
    text: '芬兰',
    code: '+358',
    value: '00358',
  },
  {
    text: '佛得角',
    code: '+238',
    value: '00238',
  },
  {
    text: '冈比亚',
    code: '+220',
    value: '00220',
  },
  {
    text: '格林纳达',
    code: '+1473',
    value: '001473',
  },
  {
    text: '格鲁吉亚',
    code: '+995',
    value: '00995',
  },
  {
    text: '哥伦比亚',
    code: '+57',
    value: '0057',
  },
  {
    text: '哥斯达黎加',
    code: '+506',
    value: '00506',
  },
  {
    text: '圭亚那',
    code: '+592',
    value: '00592',
  },
  {
    text: '荷兰',
    code: '+31',
    value: '0031',
  },
  {
    text: '洪都拉斯',
    code: '+504',
    value: '00504',
  },
  {
    text: '吉布提',
    code: '+253',
    value: '00253',
  },
  {
    text: '吉尔吉斯斯坦',
    code: '+996',
    value: '00996',
  },
  {
    text: '几内亚',
    code: '+224',
    value: '00224',
  },
  {
    text: '几内亚比绍',
    code: '+245',
    value: '00245',
  },
  {
    text: '加蓬',
    code: '+241',
    value: '00241',
  },
  {
    text: '柬埔寨',
    code: '+855',
    value: '00855',
  },
  {
    text: '津巴布韦',
    code: '+263',
    value: '00263',
  },
  {
    text: '喀麦隆',
    code: '+237',
    value: '00237',
  },
  {
    text: '卡塔尔',
    code: '+974',
    value: '00974',
  },
  {
    text: '开曼群岛',
    code: '+1345',
    value: '001345',
  },
  {
    text: '克罗地亚',
    code: '+385',
    value: '00385',
  },
  {
    text: '科摩罗',
    code: '+269',
    value: '00269',
  },
  {
    text: '科威特',
    code: '+965',
    value: '00965',
  },
  {
    text: '肯尼亚',
    code: '+254',
    value: '00254',
  },
  {
    text: '拉脱维亚',
    code: '+371',
    value: '00371',
  },
  {
    text: '莱索托',
    code: '+266',
    value: '00266',
  },
  {
    text: '立陶宛',
    code: '+370',
    value: '00370',
  },
  {
    text: '卢森堡',
    code: '+352',
    value: '00352',
  },
  {
    text: '卢旺达',
    code: '+250',
    value: '00250',
  },
  {
    text: '罗马尼亚',
    code: '+40',
    value: '0040',
  },
  {
    text: '马达加斯加',
    code: '+261',
    value: '00261',
  },
  {
    text: '马尔代夫',
    code: '+960',
    value: '00960',
  },
  {
    text: '马拉维',
    code: '+265',
    value: '00265',
  },
  {
    text: '马里',
    code: '+223',
    value: '00223',
  },
  {
    text: '毛里求斯',
    code: '+230',
    value: '00230',
  },
  {
    text: '毛里塔尼亚',
    code: '+222',
    value: '00222',
  },
  {
    text: '蒙古',
    code: '+976',
    value: '00976',
  },
  {
    text: '秘鲁',
    code: '+51',
    value: '0051',
  },
  {
    text: '摩尔多瓦',
    code: '+373',
    value: '00373',
  },
  {
    text: '摩洛哥',
    code: '+212',
    value: '00212',
  },
  {
    text: '莫桑比克',
    code: '+258',
    value: '00258',
  },
  {
    text: '墨西哥',
    code: '+52',
    value: '0052',
  },
  {
    text: '纳米比亚',
    code: '+264',
    value: '00264',
  },
  {
    text: '南非',
    code: '+27',
    value: '0027',
  },
  {
    text: '尼加拉瓜',
    code: '+505',
    value: '00505',
  },
  {
    text: '尼日尔',
    code: '+227',
    value: '00227',
  },
  {
    text: '尼日利亚',
    code: '+234',
    value: '00234',
  },
  {
    text: '挪威',
    code: '+47',
    value: '0047',
  },
  {
    text: '葡萄牙',
    code: '+351',
    value: '00351',
  },
  {
    text: '瑞典',
    code: '+46',
    value: '0046',
  },
  {
    text: '瑞士',
    code: '+41',
    value: '0041',
  },
  {
    text: '萨尔瓦多',
    code: '+503',
    value: '00503',
  },
  {
    text: '塞尔维亚',
    code: '+381',
    value: '00381',
  },
  {
    text: '塞拉利昂',
    code: '+232',
    value: '00232',
  },
  {
    text: '塞内加尔',
    code: '+221',
    value: '00221',
  },
  {
    text: '塞浦路斯',
    code: '+357',
    value: '00357',
  },
  {
    text: '塞舌尔',
    code: '+248',
    value: '00248',
  },
  {
    text: '沙特阿拉伯',
    code: '+966',
    value: '00966',
  },
  {
    text: '斯里兰卡',
    code: '+94',
    value: '0094',
  },
  {
    text: '斯洛伐克',
    code: '+421',
    value: '00421',
  },
  {
    text: '斯洛文尼亚',
    code: '+386',
    value: '00386',
  },
  {
    text: '斯威士兰',
    code: '+268',
    value: '00268',
  },
  {
    text: '苏里南',
    code: '+597',
    value: '00597',
  },
  {
    text: '塔吉克斯坦',
    code: '+992',
    value: '00992',
  },
  {
    text: '泰国',
    code: '+66',
    value: '0066',
  },
  {
    text: '坦桑尼亚',
    code: '+255',
    value: '00255',
  },
  {
    text: '特立尼达和多巴哥',
    code: '+1868',
    value: '001868',
  },
  {
    text: '土耳其',
    code: '+90',
    value: '0090',
  },
  {
    text: '土库曼斯坦',
    code: '+993',
    value: '00993',
  },
  {
    text: '突尼斯',
    code: '+216',
    value: '00216',
  },
  {
    text: '危地马拉',
    code: '+502',
    value: '00502',
  },
  {
    text: '委内瑞拉',
    code: '+58',
    value: '0058',
  },
  {
    text: '文莱',
    code: '+673',
    value: '00673',
  },
  {
    text: '乌干达',
    code: '+256',
    value: '00256',
  },
  {
    text: '乌克兰',
    code: '+380',
    value: '00380',
  },
  {
    text: '乌拉圭',
    code: '+598',
    value: '00598',
  },
  {
    text: '乌兹别克斯坦',
    code: '+998',
    value: '00998',
  },
  {
    text: '西班牙',
    code: '+34',
    value: '0034',
  },
  {
    text: '希腊',
    code: '+30',
    value: '0030',
  },
  {
    text: '匈牙利',
    code: '+36',
    value: '0036',
  },
  {
    text: '牙买加',
    code: '+1876',
    value: '001876',
  },
  {
    text: '也门',
    code: '+967',
    value: '00967',
  },
  {
    text: '意大利',
    code: '+39',
    value: '0039',
  },
  {
    text: '以色列',
    code: '+972',
    value: '00972',
  },
  {
    text: '印度',
    code: '+91',
    value: '0091',
  },
  {
    text: '印度尼西亚',
    code: '+62',
    value: '0062',
  },
  {
    text: '英国',
    code: '+44',
    value: '0044',
  },
  {
    text: '英属维尔京群岛',
    code: '+1284',
    value: '001284',
  },
  {
    text: '约旦',
    code: '+962',
    value: '00962',
  },
  {
    text: '越南',
    code: '+84',
    value: '0084',
  },
  {
    text: '赞比亚',
    code: '+260',
    value: '00260',
  },
  {
    text: '乍得',
    code: '+235',
    value: '00235',
  },
  {
    text: '智利',
    code: '+56',
    value: '0056',
  },
];
